// extracted by mini-css-extract-plugin
module.exports = {"content":"BlockContent_content__3_8PB","row":"BlockContent_row__2056w","column":"BlockContent_column__3HPqd","noPadding":"BlockContent_noPadding__3Re7P"};